import React from "react";

import { TFunction } from "react-i18next";

import { RecipesSection } from "@/components/sections/home/recipes/RecipesSection";
import { AddFavouriteDishesSection } from "@/components/sections/search/add-favourite-dishes/AddFavouriteDishesSection";
import { FavouritesSection } from "@/components/sections/search/favourites/FavouritesSection";
import { UniteRecipesSection } from "@/components/sections/search/unite-recipes/UniteRecipesSection";
import { VoteRecipeSection } from "@/components/sections/vote-recipe-section/VoteRecipeSection";

export const searchPageNavItems = (t: TFunction<"searchpage">) => [
  {
    title: t("recipes"),
    component: (
      <>
        <RecipesSection />

        <AddFavouriteDishesSection />

        <VoteRecipeSection />

        {/*<VoteRecipeSection />*/}

        <UniteRecipesSection />
        {/*<CheapestSection />*/}
        {/*<QuickestSection />*/}
      </>
    )
  },
  {
    title: t("favourites.title"),
    component: <FavouritesSection />
  }
];
